import { createContext, ReactNode, useMemo } from 'react'
import useFormRegister, {
    DEFAULT_PERSONAL_INFO,
    DEFAULT_REGISTER_INFO,
    TEducationalInfo,
    TPersonalInfo,
    TProfessionalInfo,
    TRegisterFormInfo,
    TRegisterInfo,
} from '../hooks/useFormRegister'
import { RegisterFormInfoTypes } from '../helpers/enums'

interface Props {
    children: ReactNode
}

export const RegisterContext = createContext({
    registerInfo: DEFAULT_REGISTER_INFO,
    personalInfo: DEFAULT_PERSONAL_INFO,
    professionalInfo: [],
    educationalInfo: [],
    saveInfo: () => {},
    deleteInfo: () => {},
} as {
    registerInfo: TRegisterInfo
    personalInfo: TPersonalInfo
    professionalInfo: TProfessionalInfo[]
    educationalInfo: TEducationalInfo[]
    saveInfo: (type: RegisterFormInfoTypes, info: TRegisterFormInfo, id?: string) => void
    deleteInfo: (
        type: RegisterFormInfoTypes.Professional | RegisterFormInfoTypes.Educational,
        id: string,
    ) => void
})

const RegisterProvider = ({ children }: Props) => {
    const { registerInfo, personalInfo, professionalInfo, educationalInfo, saveInfo, deleteInfo } =
        useFormRegister()

    const providerValues = useMemo(
        () => ({
            registerInfo,
            personalInfo,
            professionalInfo,
            educationalInfo,
            saveInfo,
            deleteInfo,
        }),
        [registerInfo, personalInfo, professionalInfo, educationalInfo, saveInfo, deleteInfo],
    )

    return <RegisterContext.Provider value={providerValues}>{children}</RegisterContext.Provider>
}

export default RegisterProvider
